import { render } from "./PaymentGcash.vue?vue&type=template&id=029e5e6e&scoped=true"
import script from "./PaymentGcash.vue?vue&type=script&lang=js"
export * from "./PaymentGcash.vue?vue&type=script&lang=js"

import "./PaymentGcash.vue?vue&type=style&index=0&id=029e5e6e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029e5e6e"]])

export default __exports__